/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";

/** Custom Hooks */
import useDebounce from "../../app/customHooks/useDebounce";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import SearchBar from "../../components/ui/searchBar/SearchBar";
import Buttons from "../../components/ui/button/Buttons";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import Avatar from "../../components/ui/avatar/Avtar";
import Iconify from "../../layouts/components/iconify/iconify";

/** Common Services & Data Files */
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";

/** RTK Query */
import {
  useDeleteTeamsMemberByIdMutation,
  useGetTeamMemberListMutation,
} from "../../app/services/teamMemberAPI";

/** CSS Files */
import "../teams/Teams.scss";

import AddEditTeamMembers from "./features/AddEditTeamMembers";

const TeamMembers = (props) => {
  const { confirm } = SwalAlert();
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [teamGridData, setTeamGridData] = useState([]);
  const teamId = props.teamId;

  const debouncedSearch = useDebounce(searchText, 300);

  const [
    getTeamMemberList,
    {
      isLoading: isTeamListLoading,
      isSuccess: isTeamMemberListSuccess,
      data: isTeamMemberListData,
    },
  ] = useGetTeamMemberListMutation();

  const [
    deleteTeamsMemberById,
    { isSuccess: isTeamMembersDeleted, data: deleteTeamMembersData },
  ] = useDeleteTeamsMemberByIdMutation();

  useEffect(() => {
    if (isTeamMembersDeleted && deleteTeamMembersData) {
      ToastService.success(deleteTeamMembersData.errorMessage);
      getTeamDataList();
    }
  }, [isTeamMembersDeleted && deleteTeamMembersData]);

  const getTeamDataList = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 40,
      },
      filters: {
        searchText: debouncedSearch,
      },
      teamId: teamId,
    };
    getTeamMemberList(request);
  };

  const AddhandleToggleModal = () => {
    setShowModal(!showModal);
    getTeamDataList();
  };

  useEffect(() => {
    if (isTeamMemberListSuccess && isTeamMemberListData) {
      if (isTeamMemberListData) {
        setTeamGridData(isTeamMemberListData.dataSource);
      }
    }
  }, [isTeamMemberListSuccess, isTeamMemberListData]);

  useEffect(() => {
    getTeamDataList();
  }, [teamId]);

  const handleOnSearchChange = (e) => {
    let value = e.target.value;
    setSearchText(value);
  };

  const onDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteTeamsMemberById(data.teamMemberId);
      }
    });
  };

  return (
    <div className="blue-bg-section">
      <div className="team-member">
        {/* Filter Section Start */}
        <div className="main-filter-section">
          <CardSection>
            <div className="filter-shorting-sec">
              <div className="search-input">
                <SearchBar
                  searchText="Search Team Member"
                  handleChange={handleOnSearchChange}
                />
              </div>
              <div className="right-side-section">
                <div className="add-btn">
                  <Buttons
                    buttonTypeClassName="theme-btn"
                    onClick={AddhandleToggleModal}
                    buttonText="Team Member"
                    textWithIcon={true}
                    iconName="material-symbols:add-rounded"
                    fontIcon={true}
                  />
                </div>
              </div>
            </div>
          </CardSection>
        </div>
        {/* Filter Section End */}

        <div className="table-grid">
          <div className="team-members">
            <CardSection isContentLoading={isTeamListLoading}>
              <div className="team-card-view">
                <div className="row">
                  {teamGridData?.map((member, index) => (
                    <div className="main-project-team-card" key={index + 1}>
                      <div className="project-team-member-card">
                        <div className="project-team-member-card__profile">
                          <div className="project-top-bar">
                            <div
                              className="avatar-sec"
                              style={{ position: "relative" }}
                            >
                              <Avatar
                                alt={member.userName}
                                size="medium"
                                shape="circle"
                              />

                              <div className="project-team-member-card__status active"></div>
                            </div>
                            <div className="name-sec">
                              <div className="project-team-member-card__username">
                                {member.userName}
                              </div>

                              <div className="project-team-member-card__info">
                                <div className="project-team-member-card__email">
                                  {member.emailAddress}
                                </div>
                              </div>
                            </div>

                            {props?.responsibleUser === member?.userId ? (
                              <div className='project-team-member-card__admin'>
                                <Iconify icon="eos-icons:admin-outlined" />
                              </div>
                            ) : (<button
                              className="delete-icon"
                              title="DELETE"
                              onClick={() => onDeleteClick(member)}
                            >
                              <Iconify icon="mingcute:delete-2-line" />
                            </button>)}
                          </div>
                        </div>

                        {/* <div className="project-team-member-card__action"></div> */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </CardSection>
          </div>
        </div>
        <div>
          {showModal && (
            <CenterModel
              showModal={showModal}
              handleToggleModal={AddhandleToggleModal}
              modalTitle="Add Team Member"
              modelSizeClass="w-40"
            >
              <AddEditTeamMembers onClose={AddhandleToggleModal} />
            </CenterModel>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamMembers;
